import React, { useCallback, useEffect, useState } from 'react';
import { CardContent, CardHeader, Grid } from "@mui/material";
import { Breadcrumbs, TableCard } from '../../../../Components';
import { useDispatch, useSelector } from 'react-redux';
import { fetchJobs, fetchFailedJobs } from '../Redux/Action';
import Box from "@mui/material/Box";
import useDeepEqualSelector from '../../../../Hooks/useDeepEqualSelector';
import { TableActions } from './Menus/TableActions';
import { JobsTable } from './Tables/JobsTable';

export const RosterJobs = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const filters = useSelector((store) => store.rosterJobs?.config?.filters);
    const pagination = useDeepEqualSelector((store) => store.rosterJobs.config.pagination);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        
        if (filters.view === 'failed') {
            await fetchFailedJobs({ 
                dispatch, 
                filters: { 
                    ...filters, 
                    ...pagination
                } 
            }).then((res) => {
                setIsLoading(false);
            });
        } else {
            await fetchJobs({ 
                dispatch, 
                filters: { 
                    ...filters, 
                    ...pagination
                } 
            }).then((res) => {
                setIsLoading(false);
            });
        }
    }, [filters, pagination, dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <Grid container spacing={3} elevated={3}>
            <Grid item xs={12}>
                <Box justifyContent={"space-between"} display={"flex"}>
                    <Breadcrumbs items={['ROSTER', 'JOBS']} />
                </Box>
            </Grid>
            <Grid item xs={12}>
                <TableCard>
                    <CardHeader
                        title={"Roster Generation Jobs"}
                        action={<TableActions />}
                    />
                    <CardContent>
                        <JobsTable isLoading={isLoading} setIsLoading={setIsLoading} />
                    </CardContent>
                </TableCard>
            </Grid>
        </Grid>
    );
};

